import { injectable } from 'inversify';
import { action, computed, makeObservable, observable } from 'mobx';

@injectable()
export class BoxesIndicationStore {
  @observable
  private _isOn = false;

  public constructor() {
    makeObservable(this);
  }

  @computed
  public get isOn(): boolean {
    return this._isOn;
  }

  @action
  public setCurrentIndication(indication: boolean): void {
    this._isOn = this._isOn !== indication;
  }
}
